import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-add-notes-modal',
    templateUrl: './add-notes-modal.component.html',
    styleUrls: ['./add-notes-modal.component.css'],
    standalone: false
})
export class AddNotesModalComponent {
  @Input() lead: any;
  @Input() isQuery: boolean = false;
  @Input() queryId: any;

  notesForm: FormGroup;
  isSubmitting = false;
  uid:any;
  titleLength = 0;
  titleLengths: number[] = [];
  contentLength = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,private httpService: HttpService, private toastr:ToastrService
  ) {
    this.notesForm = this.fb.group({
      notes: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.addNote(); // Add first empty note

    // Live update of character count
    this.notes.at(0).get('content')?.valueChanges.subscribe(val => {
      this.contentLength = val?.length || 0;
    });
  }

  get notes(): FormArray {
    return this.notesForm.get('notes') as FormArray;
  }

  addNote(): void {
    const noteForm = this.fb.group({
      title: [''],
      content: ['', [Validators.required]]
    });
  
    this.notes.push(noteForm);
  
    const index = this.notes.length - 1;
  
    // Initialize length arrays
    this.titleLengths[index] = 0;
    this.contentLength = 0;
  
    // Subscribe to title changes
    noteForm.get('title')?.valueChanges.subscribe(val => {
      this.titleLengths[index] = val?.length || 0;
    });
  
    // Subscribe to content changes
    noteForm.get('content')?.valueChanges.subscribe(val => {
      this.contentLength = val?.length || 0;
    });
  
    // Optional: auto-focus title input
    setTimeout(() => {
      const inputs = document.querySelectorAll('.form-control.note-title');
      const lastInput = inputs[inputs.length - 1] as HTMLInputElement;
      lastInput?.focus();
    });
  }

  
  addNotex(): void {
    this.notes.push(this.fb.group({
      title: ['', [Validators.required]],
      content: ['', [Validators.required]]
    }));
    // Set focus on the last added textarea
    setTimeout(() => {
      const textareas = document.querySelectorAll('.form-control.note-title');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });
  }

  removeNote(index: number): void {
    this.notes.removeAt(index);
  }

  // In add-notes-modal.component.ts
  onSubmit(): void {
    if (this.notesForm.invalid) {
      this.markFormGroupTouched(this.notesForm);
      return;
    }
    
    this.isSubmitting = true;

    const payload = {
      "account_status": this.lead.status,
      "notes": this.notesForm.value.notes[0].title,
      "note_content": this.notesForm.value.notes[0].content    
    };

    const id = this.lead.id;
    this.uid = localStorage.getItem('profuid');
    
    // Choose the appropriate API endpoint based on whether this is a query or lead
    const endpoint = this.isQuery 
      ? URLUtils.updateQueryStatus(id, this.uid)
      : URLUtils.updateStatus(id);
    
    // Use different HTTP methods based on whether this is a query or lead
    if (this.isQuery) {
      // For queries, use sendRePatchRequest
      this.httpService.sendRePatchRequest(endpoint, payload).subscribe({
        next: (res: any) => {
          this.toastr.success('Inquiry notes added successfully');
          this.isSubmitting = false;
          //this.activeModal.close(res);
          this.activeModal.close({
            notes: payload.notes,
            note_content: payload.note_content
          });
        },
        error: (err) => {
          this.toastr.error('Failed to add query notes');
          console.error('Error adding query notes:', err);
          this.isSubmitting = false;
        }
      });
    } else {
      // For leads, use sendPatchRequest
      this.httpService.sendPatchRequest(endpoint, payload).subscribe({
        next: (res: any) => {
          this.toastr.success('Notes added successfully');
          this.isSubmitting = false;
          //this.activeModal.close(res);
          this.activeModal.close({
            notes: payload.notes,
            note_content: payload.note_content
          });
        },
        error: (err) => {
          this.toastr.error('Failed to add notes');
          console.error('Error adding notes:', err);
          this.isSubmitting = false;
        }
      });
    }
  }
  

  // Helper method to mark all controls in a form group as touched
  private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      } else if (control) {
        control.markAsTouched();
      }
    });
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  sanitizeInput(event: any, controlName: string) {
    let input = event.target;
    let value = input.value;
  
    // Remove leading whitespace
    value = value.replace(/^\s+/, '');
  
    // Optionally: Replace `. ` inserted by double space with single space
    value = value.replace(/\. $/, ' ');
  
    input.value = value;
    this.notesForm.get(controlName)?.setValue(value, { emitEvent: false });
  }
}
